<template>
  <el-card>
    <div slot="header">
      <span>Összetevők</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="onCreate"
      >
        Új összetevő
      </el-button>
    </div>
    <list
      :ingredients="ingredients"
      :showDialog="showDialog"
      :ingredientFormType="ingredientFormType"
      @closeDialog="showDialog = false"
      @openCreateDialog="onOpenCreate"
      @openUpdateDialog="onOpenUpdate"
      @change="onChange"
      @add="onIngredientCreate"
    />
  </el-card>
</template>

<script>
  import List from './Ingredients/List';

  export default {
    components: { List },
    props: ['ingredients'],
    data() {
      return {
        showDialog: false,
        ingredientFormType: 'add',
        basicData: {},
        rules: {
          name: [
            {
              required: true,
              message: 'Név megadása kötelező',
              trigger: 'change'
            }
          ],
        }
      };
    },
    computed: {
      products() {
        return this.$store.getters['product/products'];
      },
    },
    watch: {
      product(newVal) {
        this.basicData = Object.assign({}, newVal);
      },
    },
    methods: {
      onCreate() {
        this.ingredientFormType = 'add';
        this.showDialog = true;
      },
      onIngredientCreate(ingredient) {
        this.$emit('add', {
          ...ingredient,
          key: Math.random().toString(36).substring(7),
        });
      },
      onChange(ingredients) {
        this.$emit('ingredientChange', ingredients);
      },
      onOpenCreate() {
        this.ingredientFormType = 'add';
        this.showDialog = true;
      },
      onOpenUpdate() {
        this.ingredientFormType = 'update';
        this.showDialog = true;
      },
    },
  };
</script>
